import React from "react"
// Material UI
import { makeStyles } from "@material-ui/core/styles"
import { CircularProgress } from "@material-ui/core"

const useStyles = makeStyles(() => ({
  loadingScreen: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}))

const LoadingScreen = () => {
  const classes = useStyles()
  return (
    <div className={classes.loadingScreen}>
      <CircularProgress />
    </div>
  )
}

export default LoadingScreen
